import { FixDataPage } from '../../components/FixDataPage';
import defaultSheets from '../../config/default_sheets';

const BuyerByProductFixDataPage = () => {
  return (
    <FixDataPage
      title="Fix Buyer By Product"
      columns={[
        { name: 'product', type: 'text' },
        { name: 'vendor', type: 'text' },
        { name: 'final_buyer', type: 'text' },
        { name: 'unit', type: 'text' },
        { name: 'buying_department', type: 'text' },
      ]}
      dataType={'buyer_by_product'}
      spreadsheetId={defaultSheets.BuyerByProduct.defaultSheetUrl}
      spreadsheetRange={defaultSheets.BuyerByProduct.defaultRange}
      pageId={'fix_buyer_by_product'}
    />
  );
};

export default BuyerByProductFixDataPage;
